export enum Clearances {
  CLR_VALIDATOR_IER = 'CLR_VALIDATOR_IER',
  CLR_SIGNATORY_IER = 'CLR_SIGNATORY_IER',

  CLR_VALIDATOR_SOCIO_PRO = 'CLR_VALIDATOR_SOCIO_PRO',
  CLR_SIGNATORY_SOCIO_PRO = 'CLR_SIGNATORY_SOCIO_PRO',

  CLR_VALIDATOR_RSJ = 'CLR_VALIDATOR_RSJ',

  CLR_VALIDATOR_CE = 'CLR_VALIDATOR_CE',
  CLR_SIGNATORY_CE = 'CLR_SIGNATORY_CE',
}
